<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();

const toasts = computed(() => store.getters["toastNotification/toasts"]);

const dismiss = (id) => {
  store.dispatch("toastNotification/hideToast", id);
};

const timers = ref({});

const visibleToasts = computed(() => {
  return toasts.value.filter((toast) => toast.show);
});

onMounted(() => {
  toasts.value.forEach((toast) => {
    if (toast.show && toast.duration > 0) {
      timers.value[toast.id] = setTimeout(() => {
        dismiss(toast.id);
      }, toast.duration);
    }
  });
});

const getToastStyle = (index) => {
  return {
    top: `${20 + index * 70}px`,
  };
};
</script>

<template>
  <div class="toasts-wrapper">
    <TransitionGroup name="toast-animation">
      <div
        v-for="(toast, index) in visibleToasts"
        :key="toast.id"
        :class="['toast-container', `toast-${toast.type}`]"
        :style="getToastStyle(index)"
      >
        <div class="toast-icon" v-if="toast.icon">
          <component :is="toast.icon" />
        </div>
        <div class="toast-content">
          <div v-if="toast.title" class="toast-title">{{ toast.title }}</div>
          <div class="toast-message">{{ toast.message }}</div>
        </div>
        <button
          v-if="toast.dismissible"
          class="toast-close"
          @click="dismiss(toast.id)"
        >
          ×
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toasts-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

.toast-container {
  position: fixed;
  left: 95%;
  transform: translateX(-95%);
  min-width: 300px;
  max-width: 90vw;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: flex-start;
  pointer-events: auto;
}

.toast-info {
  border-left: 4px solid #2196f3;
  background: #2196f3;
  color: #fff;
}

.toast-success {
  border-left: 4px solid #00bc8c;
  background: #00bc8c;
  color: #fff;
}

.toast-warning {
  border-left: 4px solid #ffc107;
  background: #ffc107;
  color: #000000;
}

.toast-error {
  border-left: 4px solid #e12e1c;
  background: #e12e1c;
  color: #fff;
}

.toast-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-content {
  flex: 1;
}

.toast-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.toast-message {
  word-break: break-word;
  white-space: pre-line;
}

.toast-close {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  margin-left: 12px;
  cursor: pointer;
}

.toast-close:hover {
  opacity: 0.8;
}

/* Animation */
.toast-animation-enter-active,
.toast-animation-leave-active {
  transition: top 0.5s ease;
}

.toast-animation-enter-from {
  opacity: 0;
  transform: translate(-95%, -20px);
}
.toast-animation-leave-to {
  opacity: 0;
  transform: translate(-95%, -20px);
}

.toast-animation-move {
  transition: top 1s ease;
}
</style>
